import { faClose } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useEffect, useState } from 'react'
import { useHistory } from 'react-router'
import { CardHeader, Col, Modal, Row } from 'reactstrap'

import './style.css'

const CustomModal = (props) => {
  const [showModal, setShowModal] = useState(true)
  const history = useHistory()
  const handleCloseModal = () => {
    if (props.customFn) {
      const shouldClose = props.customFn()
      if (shouldClose === false) {
        return
      }
    }
    setShowModal(false)
  }

  useEffect(() => {
    if (!showModal) {
      history.push(`/course/${props.courseId}/edit`)
    }
  }, [showModal])

  return (
    <Modal
      isOpen={showModal}
      toggle={handleCloseModal}
      centered
      size={props.size}
      style={props.style}
      className={props.className}
      enforceFocus={false}
    >
      <CardHeader className='py-3  '>
        {/* <CardHeader> */}
        <Row className='align-items-center'>
          <Col xs='8'>
            <h5 className='h3 mb-0'>{props.title}</h5>
          </Col>
          <Col className='text-right' xs='4'>
            <FontAwesomeIcon
              icon={faClose}
              size='lg'
              style={{ cursor: 'pointer' }}
              onClick={handleCloseModal}
            />
          </Col>
        </Row>
      </CardHeader>
      {props.children}
    </Modal>
  )
}

export default CustomModal
